import React, { useState, useEffect } from 'react'
import { Card, Input, QRCode, Button } from 'antd'
import { downloadTem } from '@/utils/common'
import domtoimage from 'dom-to-image'
// const logoImg = require('@/assets/images/nike_logo.png')
const CodePage = () => {
  const [codeList, setCodeList] = useState([{ value: 'NFC', label: 'NFC' }])
  useEffect(() => {
    let ls = localStorage.getItem('codeList')
    if (ls) {
      setCodeList(JSON.parse(ls))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const addNew = () => {
    setCodeList([...codeList, { value: 'NFC', label: 'NFC' }])
  }
  const valueChangeFun = (e, idx) => {
    codeList[idx].value = e.target.value
    setCodeList([...codeList])
  }
  const labelChangeFun = (e, idx) => {
    codeList[idx].label = e.target.value
    setCodeList([...codeList])
  }
  const deleteLineFun = idx => {
    codeList.splice(idx, 1)
    setCodeList([...codeList])
  }

  const cacheList = () => {
    localStorage.setItem('codeList', JSON.stringify(codeList))
  }
  const downloadCanvasQRCode = (item, idx) => {
    const element = document.getElementsByClassName('myqrcode')[idx]
    if (element) {
      domtoimage
        .toPng(element, {
          width: element.offsetWidth,
          height: element.offsetHeight,
          cacheBust: true,
          quality: 1
        })
        .then(dataUrl => {
          downloadTem(dataUrl, `${item.label}-${item.value}.png`)
        })
        .catch(error => {
          console.error('oops, something went wrong!', error)
        })
    }
  }
  return (
    <>
      <Button className="m10" type="primary" onClick={addNew}>
        添加
      </Button>
      <Button className="m10" type="primary" onClick={cacheList}>
        缓存
      </Button>
      <div className="displayFlex flexWrap justifyContentSB">
        {codeList.map((item, index) => {
          return (
            <Card key={index} style={{ width: '45%' }} className="mb20" hoverable>
              <div className="displayFlex alignCenter justifyContentCenter flexDirectionC p16">
                <div className="displayFlex alignCenter">
                  <div style={{ width: 100 }}>描述:</div>
                  <Input allowClear placeholder="描述" value={item.label} onChange={e => labelChangeFun(e, index)} />
                </div>
                <div className="displayFlex alignCenter pt10 mb10">
                  <div style={{ width: 100 }}>内容:</div>
                  <Input allowClear placeholder="-" value={item.value} onChange={e => valueChangeFun(e, index)} />
                </div>
                <div className="myqrcode bgfff displayFlex alignCenter justifyContentCenter flexDirectionC p10 br10">
                  {item.label && (
                    <div className="pb10 word_break_all" style={{ color: '#111', fontSize: 14, fontWeight: 600 }}>
                      {item.label}
                    </div>
                  )}
                  <QRCode
                    // style={{ borderRadius: 10 }}
                    bgColor="#fff"
                    value={item.value || '-'}
                    // icon={logoImg}
                    // iconSize={{ width: 40, height: 20 }}
                    style={{
                      border: '1px solid #ff5500',
                      borderRadius: 10,
                      padding: 16
                      // backgroundColor: 'rgba(255,20, 0, 0.03)',
                    }}
                  />
                  {item.value && (
                    <div className="pt10 word_break_all" style={{ color: '#707070', fontSize: 12 }}>
                      {item.value}
                    </div>
                  )}
                </div>
                <div className="alignC">
                  <Button
                    type="primary"
                    onClick={() => {
                      downloadCanvasQRCode(item, index)
                    }}
                  >
                    Download
                  </Button>
                  <Button
                    className="m10"
                    type="primary"
                    danger
                    onClick={() => {
                      deleteLineFun(index)
                    }}
                  >
                    删除
                  </Button>
                </div>
              </div>
            </Card>
          )
        })}
      </div>
    </>
  )
}
export default CodePage
